import { useEffect, useState } from 'react';
const DEFAULT_DELAY = 200; // ms;

export const useDebouncedValue = function (value) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DELAY;
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);
  return debounced;
};